import { render, staticRenderFns } from "./select-client.vue?vue&type=template&id=3334e2de&scoped=true&"
import script from "./select-client.vue?vue&type=script&lang=js&"
export * from "./select-client.vue?vue&type=script&lang=js&"
import style0 from "./select-client.vue?vue&type=style&index=0&id=3334e2de&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3334e2de",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol,VIcon,VListItemContent,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3334e2de')) {
      api.createRecord('3334e2de', component.options)
    } else {
      api.reload('3334e2de', component.options)
    }
    module.hot.accept("./select-client.vue?vue&type=template&id=3334e2de&scoped=true&", function () {
      api.rerender('3334e2de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modal/select-client.vue"
export default component.exports